<template>
  <div class="alert-sidebar">
    <div class="alert-sidebar-header">ALERT CATEGORIES</div>
    <div class="alert-sidebar-divider"></div>

    <a class="alert-sidebar-item"
       :class="{ active: activeCategory === '' || activeCategory === 'all' }"
       @click="selectCategory('all')">
      <i class="bell icon alert-sidebar-icon"></i>
      <span class="alert-sidebar-name">All Alerts</span>
      <!-- notranslate: browser page translation replaces text nodes, so Vue's count updates
           would land on a detached node and the badge stays at 0. -->
      <span :class="['alert-sidebar-count', 'notranslate', totalCountClass]" translate="no">
        {{ totalCount }}
      </span>
    </a>

    <div v-for="group in groups" :key="group.id" class="alert-sidebar-group">
      <div class="alert-sidebar-group-header">
        <span class="alert-sidebar-group-name">{{ group.name }}</span>
        <span v-for="badge in group.badges" :key="badge.text"
              :class="['alert-sidebar-badge', 'badge-' + badge.color]">
          {{ badge.text }}
        </span>
      </div>

      <a v-for="item in group.items" :key="item.id"
         v-show="isVisible(item)"
         :class="['alert-sidebar-item', { active: activeCategory === item.id }]"
         @click="selectCategory(item.id)">
        <i :class="item.icon + ' icon alert-sidebar-icon'"></i>
        <span class="alert-sidebar-name">{{ item.name }}</span>
        <span :class="['alert-sidebar-count', 'notranslate', countClass(item.id)]" translate="no">
          {{ displayCount(item.id) }}
        </span>
      </a>
    </div>
  </div>
</template>

<script>
import './styles/AlertCategoriesSidebar.css'

export default {
  name: 'AlertCategoriesSidebar',
  props: {
    alertCounts: {
      type: Object,
      default: function () { return {} }
    },
    activeCategory: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      groups: [
        {
          id: 'buybox',
          name: 'BUY BOX & PRICING',
          items: [
            { id: 'lostBuybox', name: 'Buy Box Issues', icon: 'shopping bag' },
            { id: 'price', name: 'Price Change', icon: 'dollar sign' },
            { id: 'competitorPrice', name: 'Competitor Price', icon: 'balance scale' },
            // Amazon's competitive price (external price check): tenants with the flag only.
            { id: 'competitivePrice', name: 'Competitive Price', icon: 'globe', tenantFlag: 'competitivePriceAlerts' }
          ]
        },
        {
          id: 'competitive',
          name: 'COMPETITIVE',
          items: [
            { id: 'numberOfSellers', name: 'Hijacker Alert', icon: 'user secret' }
          ]
        },
        {
          id: 'listingHealth',
          name: 'LISTING HEALTH',
          items: [
            { id: 'listingSuspended', name: 'Suspended Listings', icon: 'exclamation triangle' },
            { id: 'searchBan', name: 'Search Suppression', icon: 'search minus' },
            { id: 'reviewHealth', name: 'Review Health', icon: 'star half alternate' },
            // { id: 'noAddToCart', name: 'Add-to-Cart Button', icon: 'add to cart' }
          ]
        },
        {
          id: 'productContent',
          name: 'PRODUCT CONTENT',
          items: [
            { id: 'productDetailsRecentChange', name: 'Product Details Change', icon: 'file alternate' },
            { id: 'imageMissing', name: 'Main Image', icon: 'image' },
            { id: 'productCategoryRecentChange', name: 'Category Change', icon: 'folder open' },
            { id: 'parentProductChange', name: 'Parent Product Change', icon: 'sitemap' },
            { id: 'adultClassification', name: 'Adult Classification', icon: 'eye slash' }
          ]
        },
        {
          id: 'inventory',
          name: 'INVENTORY',
          items: [
            { id: 'inventory', name: 'FBA Stock', icon: 'circle outline' },
            { id: 'fbmInventory', name: 'FBM Stock', icon: 'warehouse' },
            { id: 'salesDrop', name: 'Sales Volume', icon: 'chart line' },
            { id: 'fbaFeeChange', name: 'FBA Fee Change', icon: 'dolly flatbed' }
          ]
        },
        {
          id: 'badges',
          name: 'BADGES',
          items: [
            { id: 'bestSellerBadge', name: 'Best Seller Badge', icon: 'trophy' },
            { id: 'prime', name: 'Prime Badge', icon: 'check' },
            // { id: 'amazonChoiceBadge', name: "Amazon's Choice", icon: 'star outline' },
            // { id: 'subscribeAndSave', name: 'Subscribe & Save', icon: 'sync' }
          ]
        }
      ]
    }
  },
  computed: {
    /** Sum alert_counts-backed totals only for categories listed in the sidebar (not computed from issue lists). */
    totalCount: function () {
      var counts = this.alertCounts || {}
      var total = 0
      for (var g = 0; g < this.groups.length; g++) {
        var items = this.groups[g].items
        for (var i = 0; i < items.length; i++) {
          if (!this.isVisible(items[i])) continue
          var id = items[i].id
          var n = counts[id]
          if (typeof n === 'number' && n > 0) total += n
        }
      }
      return total
    },
    totalCountClass: function () {
      var total = this.totalCount
      if (total === 0) return 'count-ok'
      if (total >= 5) return 'count-alert'
      return 'count-warning'
    }
  },
  methods: {
    selectCategory: function (id) {
      this.$emit('select', id === 'all' ? '' : id)
    },
    /** Hidden when the API marks the type unavailable (-1) or the tenant lacks the item's feature flag. */
    isVisible: function (item) {
      if (item.tenantFlag && !(this.$root && this.$root[item.tenantFlag] === true)) return false
      var counts = this.alertCounts
      if (counts && counts[item.id] === -1) return false
      return true
    },
    displayCount: function (id) {
      var count = this.alertCounts[id]
      if (count === undefined || count === null) return '\u2014'
      return count
    },
    countClass: function (id) {
      var count = this.alertCounts[id]
      if (count === undefined || count === null) return 'count-none'
      if (count === 0) return 'count-ok'
      if (count >= 5) return 'count-alert'
      return 'count-warning'
    }
  }
}
</script>



// WEBPACK FOOTER //
// AlertCategoriesSidebar.vue?794345fb